import { css } from '@/styled-system/css';

export const cardContentStyles = css.raw({
  'position': 'relative',
  'zIndex': 1,
  'pointerEvents': 'none',

  '& :where(a, button)': {
    pointerEvents: 'all',
  },
});
